export const isDevelopmentPatientMaskMode = () => false;


// export const isDevelopmentPatientMaskMode = () => {
//   if (typeof window === "undefined") {
//     return false;
//   }

//   const hostname = window.location?.hostname || "";
//   if (hostname === "kamkarle.oatpanel.com") {
//     return true;
//   }

//   if (process.env.NODE_ENV === "development") {
//     return true;
//   }

//   return hostname === "localhost" || hostname === "127.0.0.1";
// };
export const shouldMaskPatientDetails = (pharmacyId) =>
  String(pharmacyId) === "1502" && isDevelopmentPatientMaskMode();

export const maskPatientNamePart = (value, { wrap = false } = {}) => {
  const text = (value || "").trim();
  if (!text) return "";

  const visibleLength = text.length > 3 ? text.length - 2 : 1;
  const visible = text.slice(0, visibleLength);

  if (wrap) {
    return `XXX${text}XXX`;
  }

  return `${visible}XX`;
};

export const maskPatientPhoneLike = (value) => {
  const text = (value || "").trim();
  if (!text) return "";

  const visible = text.slice(0, Math.min(6, text.length));
  return `${visible}XXXXX`;
};

export const maskPatientAddress = (value) => {
  const text = (value || "").trim();
  if (!text) return "";

  const parts = text
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  if (parts.length === 0) {
    const visible = text.slice(0, Math.min(6, text.length));
    return `${visible} XXXXX`;
  }

  return parts
    .map((part) => {
      const visible = part.slice(0, Math.min(6, part.length));
      return `${visible} XXXXX`;
    })
    .join(", ");
};

export const maskFallbackPatientName = (value) => {
  const text = (value || "").trim();
  if (!text) return "Patient";

  const parts = text.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return maskPatientNamePart(parts[0], { wrap: true });
  }

  const [lastNameLike, firstNameLike] = parts;
  return [
    maskPatientNamePart(lastNameLike, { wrap: true }),
    maskPatientNamePart(firstNameLike),
  ]
    .filter(Boolean)
    .join(" ");
};

export const maskHeaderText = (value) => {
  const text = (value || "").trim();
  if (!text) return "";

  return text
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => {
      const upper = part.toUpperCase();
      if (upper.length <= 2) return `${upper}XX`;
      if (upper.length <= 5) return `XXX${upper}XX`;
      return `XXX${upper.slice(0, upper.length - 2)}XX`;
    })
    .join(" ");
};

export const maskEmailAddress = (value) => {
  const text = (value || "").trim();
  if (!text || !text.includes("@")) return text;

  const [localPart, domainPart] = text.split("@");
  const maskedLocal = localPart ? `${localPart.slice(0, Math.min(2, localPart.length))}XXXXX` : "XXXXX";

  if (!domainPart) {
    return maskedLocal;
  }

  const [domainName, ...domainRest] = domainPart.split(".");
  const maskedDomainName = domainName
    ? `${domainName.slice(0, Math.min(2, domainName.length))}XXXXX`
    : "XXXXX";

  return `${maskedLocal}@${[maskedDomainName, ...domainRest].filter(Boolean).join(".")}`;
};
